var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBags = function SvgBags(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.698 10.658 24 12l-12.002 7L0 12l2.301-1.342 9.697 5.658 9.7-5.658Zm-9.7 10.657-9.697-5.658L0 17l11.998 7L24 17l-2.302-1.342-9.7 5.657Zm0-19L20.03 7l-8.032 4.685L3.969 7l8.029-4.685Zm0-2.315L0 7l11.998 7L24 7 11.998 0Z"
  })));
};
export default SvgBags;